import { combineReducers } from 'redux';

import funnel from './funnel';

export const reducers = combineReducers({
  funnel,
});

export type AttendanceReducerState = ReturnType<typeof reducers>;
